<template>
  <div id="questions-edit" v-if="questionSet">
    <vx-card :title="'Edit ' + (questionSet.name ? questionSet.name : '')" class="mb-6">
      <draggable
        tag="ol"
        v-model="questionList"
        group="questions"
        draggable=".question-set"
        >
        <li v-bind:class="{editmode:item.editMode}" class="question-set pb-3" v-for="(item) in questionSet.questions" :key="item.id">
          <div class="flex mt-4 w-full" v-if="item.editMode">
            <QuestionForm v-model="questionCopy" @success="cancelEditQuestion" @cancel="cancelEditQuestion"></QuestionForm>
          </div>
          <div class="flex" v-else>
            <div class="flex-grow cursor-move">
              <div class="pt-4" v-html="item.question"></div>
              <div class="pt-1" v-html="item.additionalTerms"></div>
            </div>
            <div class="flex pt-4">
              <div class="ml-2 inline">
                <vs-tooltip text="Edit" >
                  <vs-button @click="startEditQuestion(item)" type="filled" icon-pack="feather" icon="icon icon-edit"></vs-button>
                  <span>&nbsp;</span>
                </vs-tooltip>
              </div>
              <div class="ml-2 inline">
                <vs-tooltip text="Delete" >
                  <vs-button @click="startDeleteQuestion(item)" type="border" color="danger" icon-pack="feather" icon="icon icon-trash"></vs-button>
                  <span></span>
                </vs-tooltip>
              </div>
            </div>
          </div>
        </li>
        <li slot="footer" v-if="newQuestion" class="mt-4 border-b-0">
          <QuestionForm v-model="form" @success="cancelNewQuestion" @cancel="cancelNewQuestion"></QuestionForm>
        </li>
      </draggable>
      <vs-alert :active="(!questionSet.questions || questionSet.questions.length === 0) && !newQuestion">Create your new question sets.</vs-alert>
      <vs-button v-show="!newQuestion" class=" mt-6" @click="startNewQuestion" icon-pack="feather" icon="icon-plus" icon-before>Add New Question</vs-button>
    </vx-card>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import QuestionForm from '@/views/questionSets/components/QuestionForm';
import draggable from 'vuedraggable';
export default {
  components: {
    QuestionForm,
    draggable
  },
  data () {
    return {
      isMounted: false,
      questionCopy: undefined,
      newQuestion: false,
      form: undefined,
      isOtherExpiry: false
    }
  },
  computed: {
    ...mapState('visitManagement', ['questionSet']),
    ...mapGetters('visitManagement', ['selectedQuestion']),
    questionList: {
      get () {
        return (this.questionSet.questions || []).map(item => item);
      },
      set (questions) {
        this.$store.dispatch('visitManagement/updateQuestionSet', { data: {
          ...this.questionSet,
          questions
        }})
      }
    }
  },
  methods:{
    ...mapMutations('visitManagement', {
      editQuestion: 'EDIT_QUESTION',
      cancelEditQuestion: 'CANCEL_EDIT_QUESTION'
//      fetchQuestionSet: 'SET_QUESTIONSET'
    }),
    startEditQuestion (item) {
      this.cancelNewQuestion();
      this.editQuestion(item);
    },
    async startDeleteQuestion (item) {
      await this.$store.dispatch('visitManagement/updateQuestion', {
        remove: true,
        data: item
      });
      this.cancelNewQuestion();
    },
    cancelNewQuestion () {
      this.newQuestion = false;
      this.cancelEditQuestion();
      this.form = undefined
      this.$nextTick(this.$removeTooltips);
    },
    startNewQuestion () {
      this.newQuestion = true;
      this.isOtherExpiry = false;
      this.cancelEditQuestion();
    }
  },
  created () {
    //this.fetchQuestionSet(this.$route.params.id);
    const me = this;

    // setups up questionInputTypes for QuestionForm.vue
    this.$store.dispatch('visitManagement/fetchQuestionInputTypes');

    this.$store.dispatch('visitManagement/fetchQuestionSetById', {
      id: this.$route.params.id
    })
  },
  watch: {
    selectedQuestion (question) {
      if (question) this.questionCopy = JSON.parse(JSON.stringify(question));
      this.$nextTick(this.$removeTooltips);
    }
  },
  mounted () {
    this.isMounted = true;
  }
}
</script>
<style lang="scss" scoped>
ol {
  list-style-type: decimal;
  font-size: 1.2rem;
  li {
    border-bottom: 1px solid #eee;
    padding-left: 0.75rem;
    margin-left: 1.5rem;
    min-height: 55px;
  }
}
::placeholder {
  color: #aaa;
}

</style>
